/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as _ from 'lodash';

import { TitleRow } from './appNavBits/AppNavRow';
import AppNavLeftRightNavigation from './appNavBits/AppNavLeftRightNavigation';
import Spacer from '../Spacer';
import AppNavStepProgress from './appNavBits/AppNavStepProgress';

const AppNavStep = (props) => {
  const hasSteps = _.get(props, 'stepTotal', 0) > 0;
  return (
    <div>
      <AppNavLeftRightNavigation {...props}>
        {
          hasSteps &&
            <AppNavStepProgress
              stepTotal={props.stepTotal}
              currentStep={props.currentStep}
            />
         }
        { props.titleText && <div>{ props.titleText }</div> }
      </AppNavLeftRightNavigation>

      {(props.title || props.titleContent) && <Spacer size="10" />}
      {
        props.title ? (
          <TitleRow>
            <FormattedMessage id={props.title} values={props.titleValues} />
          </TitleRow>
        ) : null
      }

      {
        props.titleContent ? (
          <div>
            <TitleRow>
              {props.titleContent}
            </TitleRow>
          </div>
        ) : null
      }
    </div>
  );
};
AppNavStep.propTypes = {
  title: PropTypes.string,
  titleValues: PropTypes.object,
  submitDisabled: PropTypes.bool,
  goBack: PropTypes.func,
  cancel: PropTypes.func,
  login: PropTypes.func,
  notification: PropTypes.func,
  submit: PropTypes.func,
  next: PropTypes.func,
  done: PropTypes.func,
  submitText: PropTypes.string,
  color: PropTypes.string,
  stepTotal: PropTypes.number,
  currentStep: PropTypes.number,
  titleContent: PropTypes.any,
  titleText: PropTypes.string,
};

export default AppNavStep;
